export interface IEnvironmentInfo {
  AuthenticationMode: 'ACTIVE_DIRECTORY' | 'INTERNAL_PASSWORD' | 'PIN_CODE' | 'DYNAMIC_CODE';
  Api: IEnvironmentAppAPI;
  WebAppUrl: string;
  Environment: 'LOCAL' | 'INTEGRATION' | 'TEST' | 'PRODUCTION';
  InactivityDurationInMinutes: number;
  /** Minutes before inactivity logout when the warning dialog is shown. Defaults to 2. */
  WarningBeforeExpirationInMinutes?: number;
  Style: IEnvironmentLogo;
  Caching?: IEnvironmentCaching;
  DialogConfig?: IEnvironmentDialogInfo;
  MapConfig?: IEnvironmentMapBox;
  DateTime: IEnvironmentDateTime;
  /** APK + PWA officiels (profil mobile « Mettre à jour »). Absent ⇒ bouton masqué. */
  MobileAppDistribution?: IMobileAppDistribution;
  /** PWA mobile publique (redirection gateway signature). */
  MobilePwaUrl?: string;
}

/** Distrib mobile : même paquet que les environnements qui exposent les URLs stables. */
export interface IMobileAppDistribution {
  apkUrl: string;
  pwaUrl: string;
}

export interface IEnvironmentDateTimeFormats {
  'fr-FR': string;
  'en-GB': string;
  'en-US': string;
  'es-ES': string;
  [culture: string]: string;
}

export interface IEnvironmentDateTime {
  StorageFormat: string;
  DisplayFormats: IEnvironmentDateTimeFormats;
  DefaultCulture: string;
  SupportedCultures: string[];
}

/** Opt-in readable date-time labels (cards, summaries). Use DateService.formatDateTimeLongForDisplay only. */
export const SHARED_LONG_DATETIME_DISPLAY_FORMATS: IEnvironmentDateTimeFormats = {
  'fr-FR': "d MMMM yyyy 'à' HH:mm",
  'en-GB': "d MMMM yyyy 'at' HH:mm",
  'en-US': "MMMM d, yyyy 'at' h:mm a",
  'es-ES': "d 'de' MMMM 'de' yyyy 'a las' HH:mm",
  'de-DE': "d. MMMM yyyy 'um' HH:mm",
  'it-IT': "d MMMM yyyy 'alle' HH:mm",
  'pt-PT': "d 'de' MMMM 'de' yyyy 'às' HH:mm"
};

export interface IEnvironmentAppAPI {
  GatewayUrl: string;
  SiteApiKey?: string;
}

export interface IEnvironmentLogo {
  HomePageLogo: string;
  HomePageLogoDM: string;
  HeaderLogo: string;
  HeaderLogoDM: string;
  LoadingPage: string;
  LoadingPageDM?: string;
  HeaderLogoClosedMenu?: string;
  HeaderLogoClosedMenuDM?: string;
}

export interface IEnvironmentCaching {
  Enabled: boolean;
  InMemory: boolean;
}

export interface IEnvironmentMapBox {
  AccessToken: string;
}

export interface IEnvironmentDialogInfo {
  /** Kill switch for explicit success toasts (`ShowSuccess`, `Show(..., { showSuccess: true })`). Success is never shown automatically. */
  ShowSuccess: boolean;
  ShowWarning: boolean;
  ShowError: boolean;
}

// Constants for shared logo paths - centralized configuration
export const SHARED_LOGO_PATHS: IEnvironmentLogo = {
  HomePageLogo: 'kiraah/logo-kiraah.svg',
  HomePageLogoDM: 'kiraah/logo-kiraah-violet-leger.svg',
  HeaderLogo: 'kiraah/logo-kiraah.svg',
  HeaderLogoDM: 'kiraah/logo-kiraah-violet-leger.svg',
  LoadingPage: 'kiraah/logo-kiraah.svg',
  HeaderLogoClosedMenu: 'kiraah/logo-kiraah-vertical.png',
  HeaderLogoClosedMenuDM: 'kiraah/logo-kiraah-vertical.png'
} as const;
